import styled from 'styled-components';
import { FaEdit, FaTrashAlt, FaStar } from 'react-icons/fa';

export const AddressTypeTitle = styled.p`
  font-family: ${(props) => props.theme.serif};
  font-size: 2.4rem;
  text-transform: uppercase;
  color: ${(props) => props.theme.black[0]};
  margin-top: 20px;
`;

export const AddressEditButton = styled(FaEdit)`
  color: ${(props) => props.theme.black[50]};
  margin-left: 15px;
  font-size: 2rem;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    color: ${(props) => props.theme.gold[50]};
  }
`;

export const AddressDeleteButton = styled(FaTrashAlt)`
  color: ${(props) => props.theme.black[50]};
  margin-left: 15px;
  font-size: 2rem;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    color: ${(props) => props.theme.gold[50]};
  }
`;

export const AddressStarButton = styled(FaStar)`
  color: ${(props) => props.theme.black[50]};
  margin-left: 15px;
  font-size: 2rem;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    color: ${(props) => props.theme.gold[50]};
  }
`;
